import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import HelpMenu from './HelpMenu';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await authAPI.login(email, password);
      const { access_token, user } = response.data;
      
      // Use user data directly from the response
      login(access_token, user);
      
      // Navigate to dashboard after successful login
      navigate('/dashboard');
      
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      if (status === 401) {
        setError('Email o contraseña incorrectos. Verificá tus datos e intentá de nuevo.');
      } else if (typeof detail === 'string') {
        setError(detail);
      } else {
        setError('No se pudo iniciar sesión. Intentá de nuevo en unos minutos.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container flex items-center justify-center">
      <div className="container-mobile w-full max-w-sm">
        {/* App Logo/Header */}
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 flex w-20 h-20 items-center justify-center">
            <img
              src={`${process.env.PUBLIC_URL || ''}/icon-192.svg`}
              alt="SiCheck"
              className="h-20 w-20 rounded-3xl shadow-md"
              width={80}
              height={80}
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">SiCheck</h1>
          <p className="text-gray-600">Control de asistencia profesional</p>
        </div>

        <form className="form-mobile" onSubmit={handleSubmit}>
          {error && (
            <div className="alert-mobile error">
              <span>⚠️</span>
              {error}
            </div>
          )}
          
          <div className="form-group-mobile">
            <label className="form-label-mobile">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-mobile"
              placeholder="Ingrese su email"
              required
              autoComplete="email"
            />
          </div>
          
          <div className="form-group-mobile">
            <label className="form-label-mobile">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-mobile"
              placeholder="Ingrese su contraseña"
              required
              autoComplete="current-password"
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className={`btn-mobile w-full mt-6 ${
              loading ? 'opacity-50 cursor-not-allowed' : 'btn-primary'
            }`}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="loading-spinner mr-2"></div>
                Ingresando...
              </div>
            ) : (
              'Ingresar'
            )}
          </button>
        </form>

        <HelpMenu variant="link" />
      </div>
    </div>
  );
};

export default Login;